import CountyLimitsLayer from './CountyLimitsLayer';
import BuildingsLayer from './BuildingsLayer';
// Auto import

export const getLayers = () => {
    return [
        CountyLimitsLayer(),
        BuildingsLayer(),
        // Auto import layers
    ];
};
